// NPM Imports
// Quote Context
// Component Imports
// JS Imports
// Asset Imports
// Bootstrap Imports
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Popover from 'react-bootstrap/Popover'

export default function Description({
   children,
   className,
   title = '',
   content,
   placement = 'top',
   popoverClassName = '',
}) {
   return (
      <div className={className}>
         <OverlayTrigger
            delay={{ show: 400, hide: 250 }}
            placement={placement}
            overlay={
               <Popover className={`popover-bhr-1 ${popoverClassName}`}>
                  {title && <Popover.Header as='h5'>{title}</Popover.Header>}
                  <Popover.Body>{content}</Popover.Body>
               </Popover>
            }
         >
            <div>{children}</div>
         </OverlayTrigger>
      </div>
   )
}
